// @flow

import {Tag} from 'docs/util';

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const SupportedPresentmentCurrencies: MarkdocTagRegistration = {
  tag: 'supported-presentment-currencies',
  component: 'SupportedPresentmentCurrencies',
  render(node, config) {
    const currencies = (config.variables.currencies: any);
    const children = node.renderChildren(config);
    return new Tag(this.tag, {currencies}, children);
  },
};
